import { showToastType } from "../utils/constants/appConstants";
import { showToast } from "../utils/utils";

export const useToast = () => {
  const success = (message) => {
    if (!message) return;
    showToast(message, showToastType.success);
  };

  const error = (err, fallback = "Something went wrong") => {
    const message =
      err?.response?.data?.message || err?.message || err || fallback;

    showToast(message, showToastType.error);
  };

  const info = (message) => {
    if (!message) return;
    showToast(message, showToastType.info);
  };

  const warn = (message) => {
    if (!message) return;
    showToast(message, showToastType.warning);
  };

  return { success, error, info, warn };
};
